import { GoalMetric, metricUnitFormatBase } from '@griply/types';

import { getLocalizedStringValue } from '../get-localized-string-value';
import { normalizeMetricUnitFormat } from '../normalize-metric-unit-format';

export const getGoalUnitFormat = (
  metric: GoalMetric | null | undefined,
  locale: string,
): string | undefined => {
  if (!metric?.unit) {
    return undefined;
  }

  const format =
    metric.unit.format ??
    `${metricUnitFormatBase} ${getLocalizedStringValue(metric.unit.name, locale)}`;

  return normalizeMetricUnitFormat(getLocalizedStringValue(format, locale));
};
